export default "__VITE_ASSET__59feeaa8__"